import Rails from '@rails/ujs'
import initVueApp from '@/main.js'

// Production bundles often trigger @rails/ujs auto-start; dev may not — avoid double start().
if (!window._rails_loaded) {
  Rails.start()
}
initVueApp()
